import React from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./SearchExplorer.scss";
import dateFormat from "dateformat";
import DocumentListView from "../DocumentExplorer/DocumentListView/DocumentListView";
import EmptyStates from "../EmptyStates/EmptyStates";
import EmptyDocumentsIcon from "../../assets/EmptyStates/empty_documents.svg";
import { getCapitals, getParsedDate } from "../../helper";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../common/UserDataReducer";
import Spinner from "react-bootstrap/Spinner";
import ShareModal from "../ShareModal/ShareModal";

const SEARCHED_DOCUMENTS = gql`
  query TagDocumentList($tagName: String!) {
    tagDocumentList(tagName: $tagName) {
      id
      title
      fileUrl
      status {
        id
        name
      }
      tag {
        id
        name
      }
      abstractJson
      folder {
        id
        parentFolder {
          id
        }
      }
      createdBy {
        id
        username
        firstName
        lastName
        email
        profile {
          role {
            id
            name
          }
        }
      }
      modifiedBy {
        firstName
        lastName
        email
        profile {
          image
          role {
            id
            name
          }
        }
      }
      modifiedTs
      documentType {
        id
        title
      }
      sharedDocument {
        id
        user {
          id
          email
          username
          firstName
          lastName
          profile {
            image
            role {
              id
              name
            }
          }
        }
        userRole {
          id
          name
        }
      }
    }
    userSharedWith {
      id
      folder {
        id
      }
      document {
        id
      }
      userRole {
        name
      }
      user {
        firstName
        lastName
        username
        profile {
          image
        }
      }
    }
  }
`;

class SearchExplorer extends React.Component {
  state = {
    documents: [],
    shareFolder: {},
    checkedShareFolder: {},
    totalCheck: 0,
    type: "document",
    key: Math.random(),
    isLoading: true,
    documentSharedWith: [],
    showShareModal: false,
    shareMultipleDocument: true,
    isZeroDocument: false,
    loadDocuments: [],
    tagName: "",
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const variables = {
      tagName: this.props.match.params.tagName,
    };

    apolloClient
      .query({
        query: SEARCHED_DOCUMENTS,
        variables: variables,
      })
      .then((result) => {
        // Shared With data--->
        let shareUsers = [];
        shareUsers = result.data.userSharedWith.filter((userShare) => userShare.document);

        let documents = [];
        documents = result.data.tagDocumentList.map((item) => {
          const fieldObj = {};
          const parsedAbstractJson = JSON.parse(item.abstractJson);
          parsedAbstractJson.map((parsedJson) => {
            return parsedJson.tabSections.map((tab) => {
              return tab.sectionFields.map((sectionField) => {
                return sectionField.inputType === "Date"
                  ? (fieldObj[sectionField.fieldLabel] = sectionField.fieldValue
                      ? dateFormat(sectionField.fieldValue, "mmm dd, yyyy")
                      : "-")
                  : sectionField.fieldLabel === "Document type" || sectionField.fieldLabel === "Document Type"
                  ? (fieldObj[getCapitals(sectionField.fieldLabel)] = item.documentType.title)
                  : sectionField.inputType === "Dropdown" && sectionField.fieldValue === undefined
                  ? (fieldObj[sectionField.fieldLabel] = "-")
                  : (fieldObj[sectionField.fieldLabel] = sectionField.fieldValue);
              });
            });
          });

          const findShareDocument = shareUsers
            .filter((shareUser) => shareUser.document.id === item.id)
            .map((user) => user.user.username);

          return {
            ...item,
            abstractJson: JSON.parse(item.abstractJson),
            folder: {
              ...item.folder,
              parentFolder: {
                id: this.props.match.params.folderId,
              },
            },
            modifiedOn: getParsedDate(item.modifiedTs),
            "Shared With": findShareDocument.join(", "),
            ...fieldObj,
          };
        });

        this.setState({
          documents: documents,
          loadDocuments: documents,
          isLoading: false,
          tagName: this.props.match.params.tagName,
          documentSharedWith: result.data.userSharedWith.filter((item) => item.document),
        });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        this.props.history.push(`/files`);
      });
  };

  componentDidUpdate(prevProps) {
    if (this.props.match.params.tagName !== prevProps.match.params.tagName) {
      this.setState({ isLoading: true });
      this.loadData();
    }
    // @Todo remove this commnet is loading of documents is proper on after some operations
    // Commented to remove un nenecessory API calls
    // if (this.props !== prevProps) {
    //   this.loadData();
    // }
  }

  setDocuments = (updateDocuments, isZeroDocument = false) => {
    this.setState({ documents: updateDocuments, isZeroDocument: isZeroDocument });
  };

  setShareFolder = (folder) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      shareFolder: { ...folder },
      type: folder.file ? "document" : false,
    });
  };

  setShareFolders = (checked, totalCheck, updatedSharedWith) => {
    this.setState({
      showShareModal: !this.state.showShareModal,
      checkedShareFolder: checked,
      totalCheck: totalCheck,
    });
  };

  sortedDocuments = (docs) => {
    return docs.sort((a, b) =>
      a.title.toLowerCase() > b.title.toLowerCase() ? 1 : a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 0
    );
  };

  handleShareModal = () => {
    if (this.state.totalCheck > 0) {
      this.setState({
        totalCheck: 0,
        showShareModal: !this.state.showShareModal,
        shareFolder: {},
      });
    } else {
      this.setState({
        showShareModal: !this.state.showShareModal,
      });
    }
  };

  setDocumentsSharedWith = (documentSharedWith) => {
    this.setState({ documentSharedWith });
  };

  updateDocuments = (documents) => {
    this.setState({ documents: documents });
  };

  render() {
    return (
      <div className="container-fluid document-search-view-wraper" id="style-scroll">
        {this.state.isLoading ? (
          <div className="loader-icon">
            <Spinner animation="border" role="status" />
          </div>
        ) : this.state.documents.length > 0 || this.state.isZeroDocument ? (
          <>
            <ShareModal
              currentUserInfo={this.props.currentUserInfo}
              showShareModal={this.state.showShareModal}
              handleShareModal={this.handleShareModal}
              shareFolder={this.state.shareFolder}
              type={this.state.type}
              setShareFolders={this.setShareFolders}
              totalCheck={this.state.totalCheck}
              checkedShareFolder={this.state.checkedShareFolder}
              setDocumentsSharedWith={this.setDocumentsSharedWith}
              setShare={() => {}}
              subFolders={this.props.subFolders}
              rootFolders={this.props.rootFolders}
              updateFolders={this.props.updateFolders}
              documents={this.state.documents}
              updateDocuments={this.updateDocuments}
              match={this.props.match}
              shareMultipleDocument={this.state.shareMultipleDocument}
            />
            <div className="search-tag-header">Search Results for {this.state.tagName}</div>
            <DocumentListView
              rootId={this.props.match.params.folderId}
              parentId={this.props.match.params.subId}
              documents={this.sortedDocuments(this.state.documents)}
              setShareFolder={this.setShareFolder}
              loadData={this.loadData}
              setDocuments={this.setDocuments}
              setShareFolders={this.setShareFolders}
              sharedWithList={this.state.documentSharedWith}
              showShareModal={this.state.showShareModal}
              loadDocuments={this.state.loadDocuments}
              isSearchDocuments={true}
              {...this.props}
            />
          </>
        ) : (
          <div className="is-size-h2 bold no-documents">
            <EmptyStates
              imgSrc={EmptyDocumentsIcon}
              emptyStateTitle="No results found !"
              description="It looks like this tag is not being used by any current documents."
              emptyStateButtons={[]}
              {...this.props}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchExplorer);
